var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label",class:_vm.classButton},[_vm._v(_vm._s(_vm.capText))])}
var staticRenderFns = []
export { render, staticRenderFns }